import mainCaller from './mainCaller';

const BASE = 'admin/api/v1/salary-settings';

// 직원 급여 설정 조회 (지점별)
export const getSalarySetting = async (employeeId, branchId, token) => {
  return await mainCaller(`${BASE}/${employeeId}?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 직원 급여 설정 저장 (생성/수정)
export const saveSalarySetting = async (data, token) => {
  return await mainCaller(BASE, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 급여산정 기간 조회
export const getSalaryPeriod = async (branchId, token) => {
  return await mainCaller(`${BASE}/period/${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 급여산정 기간 저장
export const saveSalaryPeriod = async (data, token) => {
  return await mainCaller(`${BASE}/period`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 급여 설정용 직원 목록 (직급별 그룹)
export const getSalaryEmployees = async (branchId, excludeLeft, token) => {
  return await mainCaller(
    `${BASE}/employees?branchId=${branchId}&excludeLeft=${excludeLeft}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

// 개인레슨 개별수당(회원 단위 예외) 후보 회원 목록 — 이 강사가 담당하는, 이 상품을 보유한 회원만
export const getIndividualTicketCandidateMembers = async (employeeId, branchId, courseTicketId, token) => {
  return await mainCaller(
    `${BASE}/${employeeId}/tickets/${courseTicketId}/members?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

// 개인레슨 개별수당 모달 — 이 강사가 담당중인 수강권(상품) ID 목록
export const getTrainerAssignedTicketIds = async (employeeId, branchId, token) => {
  return await mainCaller(
    `${BASE}/${employeeId}/tickets/assigned-ids?branchId=${branchId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};
